import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import EmbedHelper, { embedTypesList } from "../../utils/EmbedHelper";
import { EmbedInfo } from "../../utils/embeds/types";
import { CallerWithEmbedRequestReturn } from "../../utils/types/caller";

declare var ko: any;

export class embedder_template extends vnTemplate {

    protected toolTipButton : infoButton_template;

    protected embedHelper: EmbedHelper;

    /**
     * The supplied caller is expected to have the onGenerateEmbedRequestReturn and getIdBrand functions defined.
     *
     * @param id
     * @param viewModel
     * @param caller
     */
    constructor(id: string, viewModel: any, caller: CallerWithEmbedRequestReturn) {

        super(id, viewModel, caller);
    }

    protected getTemplateHtml(): string {

        return /* html */`

                <div data-bind="css: { 'is-visible': isEmbedPopUpVisible }" class="w-lightbox light-theme lightbox-embed">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">

                            <div class="form-header">
                                <h3 class="form-title">Insert Embed</h3>
                                <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCloseEmbedPopup }" ></button>
                            </div>


                            <div class="form-body">

                                 <div class="form-group">
                                    <button class="btn-form options icon i-dropdown-simple is-open" type="button" data-bind="event: { click: onClickToggleEmbedTypes }">Supported Platforms </button>
                                    <div class="inner-group" data-bind="foreach: embedType_options" >
                                        <div>
                                            <input type="radio" data-bind="checked: $parent.embedType, event:{change: $parent.onChangeEmbedInput}, attr: { value: $data.type, id: $data.type }">
                                            <label class="form-label" for="active_no" data-bind="text: $data.name, attr: { for: $data.type }"></label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div style="display: flex;align-items: center">
                                        <label class="form-label" for="embedSource">Embed Creator</label>
                                        <div class="w-tooltips-adv pos-top">
                                            ${this.toolTipButton.getHtmlBuild()}
                                        </div>
                                    </div>
                                    <textarea style="width: 100%;height: 100px;" id="embedSource" placeholder="paste supported link or full embed code here" data-bind="textInput: embedSource, event: { input: onChangeEmbedInput }, valueUpdate : ['afterkeydown','propertychange','input'], hasFocus: isEmbedFocused" class="input-text"></textarea>
                                </div>
                                <div class="error form-group">
                                    <p class="form-text" data-bind="text: embedErrors().message" />
                                    <ul data-bind="foreach:embedErrors().softMatches">
                                        <li >
                                            <p class="form-text" data-bind="text: $data" /></p>
                                        </li>
                                    </ul>
                                    <p class="form-text" data-bind="if: embedErrors().softMatches && embedErrors().softMatches.length>0 ">Please choose a specific supported platform from the list.</p>
                                </div>

                                <div class="preview" data-bind="visible: embedCode">
                                    <div class="form-group">
                                        <label class="form-label" for="embedSource" data-bind="class: previewEmbedType">Embed Code Preview</label>
                                        <pre class="scrollable"  data-bind="text: embedCode, disable: true" ></pre>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group" id="embedGeneration">
                                <section id="calculation" hidden>
                                    <h2 class="form-title embed-animation">Generating Embed…</h2>
                                    <progress style="display: block;width: 100%;margin-bottom: 10px;"></progress>
                                    <p>
                                        Checking width:
                                        <span id="current-viewport-width"></span>
                                        <span>x</span>
                                        <span id="current-viewport-height"></span>
                                    </p>
                                </section>
                            </div>

                            <div class="form-footer">

                                <button type="button" data-bind="event: { click: onClickCloseEmbedPopup }" class="btn ">Cancel</button>
                                <button type="button" data-bind="disable: embedCode() == null || embedErrors() == null,  event: { click: onClickAddEmbed }" class="btn highlight">Insert</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="position:fixed;left:0;top:0;z-index:-1;opacity:0;pointer-events:none;">
                    <div id="iframe-wrapper">
                        <iframe src="about:blank"></iframe>
                    </div>
                </div>
            `;
    }

    protected initPartial() {

        this.toolTipButton = new infoButton_template('toolTip', this.getTemplateViewModel(), this.caller)
        this.toolTipButton.setTitle('Help: Embed');
        this.embedHelper = new EmbedHelper(this.caller);

        let toolTipText =  '' +
            '<div style="display: flex;align-items: flex-start">' +
            '<video src="/assets/videos/article-embed.mp4" autoplay loop muted style="width: 40%; float: left; margin: 0 10px 5px 0;"></video><br>' +
            '<div>' +
            '<p>Paste into this text box information to generate the embed code.  The following are accepted:</p>' +
            '<ul>' +
            '<li>Full URL from supported platforms</li>' +
            '<li>ID of a post from supported platforms</li>' +
            '<li>Full embed code in html</li>' +
            '</ul>' +
            '</div>' +
            '</div>'
        ;

        this.toolTipButton.setContent(toolTipText);
    }

    protected getTemplateName(): string {
        return "embedder-template";
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        let viewModel = {

            isEmbedPopUpVisible: ko.observable(false),
            isEmbedFocused:ko.observable(false),
            embedSource:ko.observable(null),
            embedCode:ko.observable(null),
            embedErrors: ko.observableArray([]),
            embedType_options: ko.observableArray(embedTypesList()),
            embedType: ko.observable('all'),
            previewEmbedType: ko.observable(''),

            onClickCloseEmbedPopup: function (data, event) {
                huit_neuf_this.onClickCloseEmbedPopup();
            },
            onClickToggleEmbedTypes: function (data, event) {
                huit_neuf_this.onClickToggleEmbedTypes();
            },
            onClickAddEmbed:function (data, event) {
                huit_neuf_this.onClickAddEmbed();
            },
            onChangeEmbedInput:function (data, event) {
                huit_neuf_this.onChangeEmbedInput();
            },
            resetEmbedPopUp:function (data, event) {
                huit_neuf_this.resetEmbedPopUp();
            }
        };
        return viewModel;
    }

    public toggleEmbedPopUp(value){

        document.body.classList.toggle("is-fixed");
        this.getTemplateViewModel().isEmbedPopUpVisible(value)
    }

    public async setEmbedData(embedData: EmbedInfo) {

        this.getTemplateViewModel().previewEmbedType('embed_'+ embedData.name);

        let markup = embedData.html;
        markup = await this.embedHelper.processContentEmbed(embedData);

        this.getTemplateViewModel().embedCode(markup);
    }

    public onClickCloseEmbedPopup(){

        this.embedHelper.abortEmbedGeneration();
        this.toggleEmbedPopUp(false);
        this.resetEmbedPopUp();
    }

    public resetEmbedPopUp(){

        this.getTemplateViewModel().isEmbedFocused(false);
        this.getTemplateViewModel().embedSource(null);
        this.getTemplateViewModel().embedType('all');
        this.clearEmbedFormOutput();
        document.getElementsByClassName('inner-group')[0].classList.remove('is-open');
        document.getElementsByClassName('btn-form options')[0].classList.add('is-open');
    }

    public clearEmbedFormOutput(){

        this.getTemplateViewModel().embedCode(null);
        this.getTemplateViewModel().embedErrors([]);
    }

    protected onClickAddEmbed(){

        this.caller.addEmbedCodeToPage(this.getTemplateViewModel().embedCode());
    }

    public onClickToggleEmbedTypes(){

        this.getTemplateViewModel().embedType('all');
        document.getElementsByClassName('inner-group')[0].classList.toggle('is-open');
        document.getElementsByClassName('btn-form options')[0].classList.toggle('is-open');

        let element = document.getElementsByClassName('inner-group')[0];
        if(!element.classList.contains('is-open')){

            this.onChangeEmbedInput();
        }
    }

    protected onChangeEmbedInput(){

        //clear result
        this.clearEmbedFormOutput();

        // get input and make call of >3
        let source = this.getTemplateViewModel().embedSource();
        if (source && source.length >= 3) {

            this.caller.generateEmbed(source)
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/embedder_template.ts